<template>
  <div
    style="text-align: right;"
  >
    <el-tooltip
      class="item"
      effect="dark"
      content="Módosítás"
      placement="top"
      v-can="'representativepayment.update'"
    >
      <el-button
        size="mini"
        icon="el-icon-edit"
        style="margin-left: 5px;"
        @click="updateRepresentativePayment"
      />
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      :content="'Törlés'"
      placement="top"
      style="margin-left: 5px;"
      v-can="'representativepayment.delete'"
    >
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteRepresentativePayment"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          size="mini"
          icon="el-icon-delete"
        />
      </el-popover>
    </el-tooltip>
  </div>
</template>

<script>
  export default {
    props: ['representativePayment'],
    data() {
      return {
        deleteButtonLoader: false,
        deleteConfirmVisible: false,
      };
    },

    methods: {
      async deleteRepresentativePayment() {
        this.deleteButtonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('representativePayment/delete', this.representativePayment.id);
          this.$store.dispatch('representativePayment/fetchAll');
        } catch (e) {
        }
        this.deleteButtonLoader = false;
      },
      async updateRepresentativePayment() {
        this.$router.push('/representative-processes/payments/update/' + this.representativePayment.id);
      },
    }
  };
</script>
